import React from 'react';

const StartupIcerik = () => {
    return (
        <div className="about-area ptb-80 bg-f9f6f6">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12">
                        <div className="about-content">
                            <div className="section-title">
                                <h2>Yazılım ve Teknoloji Ortaklığı</h2>
                                <div className="bar"></div>
                            </div>

                            <p>
                                Yenilikçi bir fikri başarılı bir dijital ürüne dönüştürmek, yalnızca yazılım geliştirmekten çok daha fazlasını gerektirir. Pixel Yazılım olarak girişimcilerin ve start-up ekiplerinin projelerini fikir aşamasından başlayarak analiz ediyor; ihtiyaçların belirlenmesi, teknik altyapının planlanması, kullanıcı deneyimi tasarımı, yazılım geliştirme, test ve yayınlama süreçlerinde çözüm ortağı olarak yanlarında yer alıyoruz.
                            </p>

                            <p>
                                Mobil uygulama, web platformu, yönetim paneli, pazar yeri, abonelik sistemi veya sektöre özel yazılım projelerini; büyümeye, yeni özellikler eklemeye ve değişen kullanıcı ihtiyaçlarına uyum sağlamaya uygun şekilde geliştiriyoruz. İlk aşamada projenin temel özelliklerini içeren bir MVP oluşturarak fikrin daha kısa sürede kullanıcılarla buluşmasını, geri bildirimlerle geliştirilmesini ve yatırım süreçlerine daha hazır hâle gelmesini sağlıyoruz.
                            </p>

                            <p>
                                Geliştirme sürecinde yalnızca mevcut ihtiyaca odaklanmıyor; projenin gelecekte ulaşabileceği kullanıcı sayısını, ihtiyaç duyacağı entegrasyonları, veri güvenliğini ve sürdürülebilirliğini de göz önünde bulunduruyoruz. Böylece girişimcilerin teknik ayrıntılarla vakit kaybetmeden ürünlerine, kullanıcılarına ve iş modeline odaklanabileceği güvenilir bir teknoloji altyapısı oluşturuyoruz.
                            </p>

                            <p>
                                Fikrinizi anlatın, teknik süreci birlikte planlayalım ve projenizi çalışan, geliştirilebilir ve ölçeklenebilir bir dijital ürüne dönüştürelim.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StartupIcerik;
